import React, { ReactNode } from 'react'
import { StyleSheet, View, ViewStyle } from 'react-native'
import { useSafeAreaInsets } from 'react-native-safe-area-context'
import { useTheme } from '@react-navigation/native'
import { Theme } from '@theme'
import { StatusBar, StatusBarStyle } from 'expo-status-bar'
import { useDarkModeStore } from '@store'
import { LoadingView } from '../molecules'

type ScreenProps = {
  children: ReactNode
  isPending?: boolean
  paddingTop?: number
  noPaddingTop?: boolean
  noPaddingBottom?: boolean
  paddingHorizontal?: boolean
  paddingBottom?: boolean
  statusBarStyle?: StatusBarStyle
  style?: ViewStyle
}

export const Screen = ({
  children,
  isPending,
  paddingTop,
  noPaddingTop,
  noPaddingBottom,
  paddingHorizontal,
  paddingBottom,
  statusBarStyle,
  style,
}: ScreenProps): React.ReactElement => {
  const theme = useTheme()
  const styles = getStyle(theme)

  const { darkMode } = useDarkModeStore()

  const { top, bottom } = useSafeAreaInsets()

  return (
    <>
      <View
        style={[
          styles.container,
          {
            paddingTop: noPaddingTop ? undefined : (paddingTop || top),
            paddingBottom: noPaddingBottom? 0 : (paddingBottom ? theme.spacing.xxxl : bottom),
          },
          style
        ]}
      >
        <StatusBar style={statusBarStyle || darkMode ? 'light' : 'dark'} />

        <View style={[paddingHorizontal && styles.padding, styles.flex]}>{children}</View>
      </View>

      <LoadingView isLoading={Boolean(isPending)} />
    </>
  )
}

const getStyle = (theme: Theme) =>
  StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: theme.colors.background,
    },
    padding: {
      paddingHorizontal: theme.spacing.xl,
    },
    flex: {
      flex: 1,
    },
  })
